module.exports = __webpack_public_path__ + "media/images/athletes/3584-a269a851b956b587049f87b0f3736c2a.png";